// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MIK1","placeholdersHeader":"styles_placeholdersHeader__3Xgvn","editorStyle":"styles_editorStyle__KupP3","placeholdersBox":"styles_placeholdersBox__v0hiX"};